import React from 'react';
import { VerbenaProps } from '../../../interfaces/components';
import VerbenaImage from '../../../assets/images/Verbena.jpg';
import VerbenaLogo from '../../../assets/images/VerbenaLogo.png';
import { VerbenaContent } from '../../../content';
import CollectionIntroModal from './index';

const VerbenaCollection = ({ activeLocale, active, setActive }: VerbenaProps) => {
  return (
    <CollectionIntroModal
      productImage={VerbenaImage}
      productLogo={VerbenaLogo}
      title={VerbenaContent[activeLocale as keyof typeof VerbenaContent].title}
      description={VerbenaContent[activeLocale as keyof typeof VerbenaContent].text}
      activeLocale={activeLocale}
      active={active}
      setActive={setActive}
    />
  );
};

export default VerbenaCollection;
